/* Bolsilab — interacciones propias (prefijo mt-) */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveals al hacer scroll (un único observer)
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.mt-reveal, [data-mt-dibuja]').forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      if (!io || reduce) { el.classList.add('mt-visible'); return; }
      io.observe(el);
    });
  }

  // Héroe: el foco sigue al cursor
  function initFoco(root) {
    root.querySelectorAll('[data-mt-foco]').forEach(function (el) {
      if (el.dataset.mtInit || reduce) return;
      el.dataset.mtInit = '1';
      var foco = el.querySelector('.mt-hero__foco');
      if (!foco || window.matchMedia('(hover: none)').matches) return;
      var raf = null;
      el.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var r = el.getBoundingClientRect();
          foco.style.setProperty('--mt-fx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          foco.style.setProperty('--mt-fy', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
          raf = null;
        });
      });
    });
  }

  // Hotspots: punto y lista sincronizados
  function initHotspots(root) {
    root.querySelectorAll('[data-mt-hotspots]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var nodos = el.querySelectorAll('[data-mt-hs]');
      function activar(n) {
        nodos.forEach(function (x) { x.classList.toggle('mt-activo', x.dataset.mtHs === n); });
      }
      nodos.forEach(function (x) {
        x.addEventListener('mouseenter', function () { activar(x.dataset.mtHs); });
        x.addEventListener('click', function () { activar(x.dataset.mtHs); });
      });
    });
  }

  // FAQ
  function initFaq(root) {
    root.querySelectorAll('[data-mt-faq]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      el.querySelectorAll('.mt-faq__pregunta').forEach(function (b) {
        b.addEventListener('click', function () {
          var item = b.closest('.mt-faq__item');
          var abierto = item.classList.toggle('mt-abierto');
          b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        });
      });
    });
  }

  // Página de producto: galería, variantes y cantidad
  function initPdp(root) {
    root.querySelectorAll('[data-mt-pdp]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var principal = el.querySelector('[data-mt-principal]');
      var minis = el.querySelectorAll('[data-mt-mini]');
      function mostrar(src, mediaId) {
        if (!principal || !src) return;
        principal.style.opacity = '0';
        setTimeout(function () { principal.src = src; principal.style.opacity = '1'; }, 150);
        minis.forEach(function (m) { m.classList.toggle('mt-activo', mediaId && m.dataset.mtMedia === String(mediaId)); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrar(m.dataset.mtMini, m.dataset.mtMedia); });
      });

      var datos = el.querySelector('[data-mt-variantes]');
      var variantes = [];
      try { variantes = JSON.parse(datos.textContent); } catch (e) {}
      var input = el.querySelector('[data-mt-variante]');
      var boton = el.querySelector('[data-mt-boton]');
      var precio = el.querySelector('[data-mt-precio-actual]');
      var antes = el.querySelector('[data-mt-precio-antes]');
      var mensaje = el.querySelector('[data-mt-mensaje]');
      var radios = el.querySelectorAll('[data-mt-opcion]');
      var packs = el.querySelectorAll('[data-mt-pack]');
      var cantPack = el.querySelector('[data-mt-cantidad]');
      function textoBoton() {
        var p = Array.prototype.find.call(packs, function (x) { return x.checked; });
        if (!p) return boton.dataset.texto;
        return boton.dataset.texto + ' · ' + p.dataset.total;
      }
      // Un color por unidad cuando el pack es de 2 o más
      var bloqueUnidades = el.querySelector('[data-mt-unidades]');
      var colorUnico = el.querySelector('[data-mt-color-unico]');
      var filas = bloqueUnidades ? bloqueUnidades.querySelectorAll('[data-mt-unidad]') : [];
      function pintarPunto(sel) {
        var o = sel.options[sel.selectedIndex];
        var punto = sel.parentNode.querySelector('[data-mt-unidad-punto]');
        if (o && punto) punto.style.background = o.dataset.punto || '';
      }
      function packActual() {
        var p = Array.prototype.find.call(packs, function (x) { return x.checked; });
        return p ? (+p.value || 1) : 1;
      }
      function aplicarPack() {
        var n = packActual();
        if (cantPack) cantPack.value = n;
        if (bloqueUnidades) {
          var multi = n > 1;
          bloqueUnidades.hidden = !multi;
          if (colorUnico) colorUnico.classList.toggle('mt-oculto', multi);
          filas.forEach(function (f, i) {
            f.hidden = i >= n;
            var sel = f.querySelector('select');
            if (sel && !sel.dataset.tocado && input) sel.value = input.value;
            if (sel) pintarPunto(sel);
          });
        }
        if (!boton.disabled || (bloqueUnidades && n > 1)) {
          boton.disabled = false;
          boton.textContent = textoBoton();
        }
      }
      filas.forEach(function (f) {
        var sel = f.querySelector('select');
        if (!sel) return;
        pintarPunto(sel);
        sel.addEventListener('change', function () {
          sel.dataset.tocado = '1';
          pintarPunto(sel);
          var v = variantes.find(function (x) { return String(x.id) === sel.value; });
          if (v && v.img) mostrar(v.img, v.media);
        });
      });
      packs.forEach(function (p) { p.addEventListener('change', aplicarPack); });
      if (packs.length) aplicarPack();

      // Barra fija de compra: aparece cuando el botón principal queda por encima de la pantalla
      var barra = el.querySelector('[data-mt-barra]');
      if (barra && boton) {
        var barraPrecio = barra.querySelector('[data-mt-barra-precio]');
        var barraBoton = barra.querySelector('[data-mt-barra-boton]');
        var refrescarBarra = function () {
          var p = Array.prototype.find.call(packs, function (x) { return x.checked; });
          if (barraPrecio) barraPrecio.textContent = p ? p.dataset.total : precio.textContent;
          if (barraBoton) barraBoton.disabled = boton.disabled;
        };
        packs.forEach(function (p) { p.addEventListener('change', refrescarBarra); });
        radios.forEach(function (r) { r.addEventListener('change', function () { setTimeout(refrescarBarra, 50); }); });
        refrescarBarra();
        var pendiente = false;
        var revisarBarra = function () {
          pendiente = false;
          var pasado = boton.getBoundingClientRect().bottom < 0;
          barra.classList.toggle('mt-barra--visible', pasado);
          barra.setAttribute('aria-hidden', pasado ? 'false' : 'true');
          if (barraBoton) barraBoton.tabIndex = pasado ? 0 : -1;
        };
        window.addEventListener('scroll', function () {
          if (pendiente) return;
          pendiente = true;
          setTimeout(revisarBarra, 60);
        }, { passive: true });
        revisarBarra();
        barraBoton.addEventListener('click', function () {
          var n = packActual();
          // Con un pack de varias unidades, primero que vea los colores elegidos
          if (n > 1 && bloqueUnidades) {
            bloqueUnidades.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            return;
          }
          boton.click();
        });
      }

      // Envío: si hay varias unidades con colores, se añaden todas de una vez
      var form = boton ? boton.closest('form') : null;
      if (form && bloqueUnidades) {
        form.addEventListener('submit', function (ev) {
          var n = packActual();
          if (n < 2) return;
          ev.preventDefault();
          var cuenta = {};
          filas.forEach(function (f, i) {
            if (i >= n) return;
            var id = f.querySelector('select').value;
            cuenta[id] = (cuenta[id] || 0) + 1;
          });
          var items = Object.keys(cuenta).map(function (id) { return { id: +id, quantity: cuenta[id] }; });
          boton.disabled = true;
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message));
              window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
            })
            .catch(function (e) {
              boton.disabled = false;
              if (mensaje) mensaje.textContent = (e && e.message) || 'No se ha podido añadir. Inténtalo de nuevo.';
            });
        });
      }
      if (packs.length && boton && !boton.disabled) boton.textContent = textoBoton();
      function actualizar() {
        var elegidas = [];
        radios.forEach(function (r) { if (r.checked) elegidas[+r.dataset.mtOpcion] = r.value; });
        elegidas.forEach(function (val, i) {
          var span = el.querySelector('[data-mt-opcion-valor="' + i + '"]');
          if (span) span.textContent = val;
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) {
          boton.disabled = true; boton.textContent = 'No disponible';
          return;
        }
        input.value = v.id;
        precio.textContent = v.price;
        if (v.compare) { antes.textContent = v.compare; antes.hidden = false; } else { antes.hidden = true; }
        boton.disabled = !v.available;
        boton.textContent = v.available ? textoBoton() : boton.dataset.agotado;
        if (mensaje) mensaje.textContent = '';
        if (v.img) mostrar(v.img, v.media);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      radios.forEach(function (r) { r.addEventListener('change', actualizar); });

      var cant = el.querySelector('input[name="quantity"]');
      var menos = el.querySelector('[data-mt-menos]');
      var mas = el.querySelector('[data-mt-mas]');
      if (cant && menos && mas) {
        menos.addEventListener('click', function () { cant.value = Math.max(1, (+cant.value || 1) - 1); });
        mas.addEventListener('click', function () { cant.value = (+cant.value || 1) + 1; });
      }
    });
  }

  function initTodo(ev) {
    var root = (ev && ev.target && ev.target.querySelectorAll) ? ev.target : document;
    initReveals(root);
    initFoco(root);
    initHotspots(root);
    initFaq(root);
    initPdp(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
